module.exports = __webpack_public_path__ + "media/country_flags/sd-17fd3b42.png";